import './styles.css'
class TableWithChild extends React.Component {
  shouldComponentUpdate (nextProps, nextState) {
    return false
  }
  render () {
    let {
      headerBody,
      childBody,
      footBody,
      tableClass,
      headerBodyClassName,
      childBodyClassName,
      footBodyClassName} = this.props
    return (
      <table className={`table mk-table-summary mk-table-fixed-hf report-table ${tableClass}`}>
        <thead>
          <tr>
            { headerBody.map((val, pidx) => {
              return <th className={headerBodyClassName[pidx]}>{val}</th>
            })
            }
          </tr>
        </thead>
        <tbody>
          { childBody.map((val, pidx) => {
            let valObj = Object.values(val.data)
            return (<tr>
              {valObj.map((value, pidx) => {
                return <td className={`${childBodyClassName[pidx]} ${!val.isParent ? 'child' : ''} ${val.isParent ? 'parent' : ''}`}>{value}</td>
              })}
            </tr>)
          })}
        </tbody>
        <tfoot>
          <tr className='divider text-total'>
            {Object.values(footBody).map((value, pidx) => {
              return <td className={footBodyClassName[pidx]}><b>{value}</b></td>
            })}
          </tr>
        </tfoot>
      </table>
    )
  }
}

export default TableWithChild



// WEBPACK FOOTER //
// ./app/pages/Reports/Sales/ModifierSales/TableWithChild/TableWithChild.js